import app from 'flarum/common/app';
import icon from 'flarum/common/helpers/icon';
import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';
import extractText from 'flarum/common/utils/extractText';

export default class ForumStatsWidget extends Widget {
  className(): string {
    return 'Litalino-ForumStatsWidget';
  }

  icon(): string {
    return 'fas fa-chart-pie';
  }

  title(): string {
    return extractText(app.translator.trans('flarum-forum-stats-widget.forum.widget.title'));
  }

  content() {
    const stats = app.forum.attribute('bj-community-bje-stats-widget.stats');
    const disable = ["Blog", "Online Guests", "Online Users"];
    return (
      <div id="stats-widget">
        <h4>Statistik</h4>
        <ul className="ForumStatsWidget">
          {Object.keys(stats).map((stat) => (
            !disable.includes(stats[stat].label) ? <li>
              {icon(stats[stat].icon)}
              {stats[stat].label}
              <div class="pill">{stats[stat].prettyValue}</div>
            </li> : <></>
          ))}
        </ul>
      </div>
    );
  }
}
